import { StyleSheetManager, ThemeProvider } from 'styled-components';
import { getTheme, isValidProp } from '@belong/themes';
import { Button } from '../../actions/Button';
import { BaseModal } from './BaseModal';

export const Modal: typeof BaseModal = ({ ...props }) => (
  <ThemeProvider theme={getTheme()}>
    <StyleSheetManager shouldForwardProp={isValidProp}>
      <BaseModal ButtonComponent={Button} {...props} />
    </StyleSheetManager>
  </ThemeProvider>
);

Modal.displayName = 'Modal';
